import { OrderDirection } from "@/constants/orderDirection";
import { z } from "zod";
import { SortableColumns } from "./-constants";

export const SearchSchema = z.object({
  sortColumn: z.enum(SortableColumns).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
